<div class="w-full h-[100vh] flex lg:grid lg:grid-cols-[60%,_1fr]">
  <div class="w-full hidden lg:flex flex-col p-[35px] gap-[50px] bg-[#081A46]">
    <div><img src="../../../assets/icons/_$udo_white.svg" alt="" /></div>
    <div class="w-full h-full flex flex-col gap-[10px] justify-end">
      <span class="text-[50px] font-[700] text-[#fff]">Sudo Rewards</span>
      <div class="typing-effect">
        {{ currentText }}<span class="cursor">|</span>
      </div>
    </div>
  </div>
  <div
    class="w-full h-full flex flex-col justify-center lg:items-start items-center sm:px-[40px] p-[20px] gap-[40px]"
  >
    <div class="flex max-w-[500px] w-full flex-col gap-[5px]">
      <span class="text-[28px] font-[700]">Welcome Back!</span>
      <span class="text-[14px] text-slate-500 font-[600]">{{
        OTPState
          ? "Enter the OTP sent to your email"
          : "Enter your email to receive a one-time password"
      }}</span>
    </div>
    <div class="flex max-w-[500px] flex-col w-full gap-[20px]">
      <div class="flex flex-col gap-[10px] w-full">
        <div class="w-full">
          <div *ngIf="!OTPState">
            <app-input
              [label]="'Email Address'"
              [placeholder]="'Enter email address'"
              (returnValue)="setEmail($event)"
              [error]="errors.emailAddress"
            ></app-input>
          </div>
          <div *ngIf="OTPState" class="w-full mb-[20px]">
            <app-otp-field (OTPReturnValue)="setOTP($event)"></app-otp-field>
          </div>
        </div>
        <!-- <app-button
          [label]="'Sign In'"
          (onClick)="sendOTP()"
          [className]="
            'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
          "
        ></app-button> -->
        <div *ngIf="!OTPState" class="w-full">
          <app-button
            [label]="'Send OTP'"
            (onClick)="sendOTP()"
            [loading]="loading"
            [className]="
              'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
            "
          ></app-button>
        </div>
        <div *ngIf="OTPState" class="w-full">
          <app-button
            [label]="'Sign In'"
            (onClick)="signIn()"
            [loading]="loading"
            [className]="
              'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
            "
          ></app-button>
        </div>
      </div>
      <div class="w-full flex justify-end">
        <span class="text-[12px] font-[500]"
          >Dont have an account?
          <span (click)="routeTo('register')" class="font-[800] text-slate-400"
            >Register</span
          ></span
        >
      </div>
    </div>
  </div>
</div>
